import React, { Component } from "react"
import { connect } from "react-redux"
import { requestResource } from "home/api_request"
import { BnccStudentPerformanceTablePresentation } from "home/components/bncc_proficiency_analysis"
import TableWrapper from "home/components/table_wrapper"

const RESOURCE = "bncc_proficiency_analysis/student_performance"

class BnccStudentPerformanceTableContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      tableData: {
        data: null,
        columns: null
      }
    }
  }

  componentDidMount () {
    this.updateData()
  }

  componentDidUpdate (prevProps) {
    if (JSON.stringify(prevProps.filters) != JSON.stringify(this.props.filters)) {
      this.updateData()
    }
  }

  updateData () {
    const { filters } = this.props

    requestResource(RESOURCE, filters, response => this.setChartConfigFromResponse(response))
  }

  setChartConfigFromResponse (response) {
    this.setState({
      tableData: response.data
    })
  }

  render () {
    return (
      <TableWrapper
        presenter={BnccStudentPerformanceTablePresentation}
        tableData={this.state.tableData}
        resource={RESOURCE}
        filters={this.props.filters}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    filters: {
      userId: state.filters.userId,
      schoolYear: state.filters.schoolYear,
      schoolClass: state.filters.schoolClass,
      schoolId: state.filters.schoolId,
      "bnccAnalysis/studentPerformance/examId": state.filters["bnccAnalysis/studentPerformance/examId"]
    }
  }
}

export default connect(mapStateToProps)(BnccStudentPerformanceTableContainer)
